module.exports = __webpack_public_path__ + "static/media/img_d_clock@2x.3be8ae44.png";